<template>
  <b-card no-body>
    <div slot="header" class="p-2">Detalle de orden</div>
    <b-table :items="detalles" :fields="fields" responsive>
        <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
        <template #cell(subtotal)="data">{{data.value | currency}}</template>
    </b-table>
  </b-card>
</template>

<script>
import axios from "axios";
let loadUpApi = "pedidos/loadup/";
export default {
  props: {
    value: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      detalles: [],
      fields: [
          {key: 'nombre', sortable: true},
          {key: 'sku', sortable: true, label: 'SKU'},
          {key: 'modelo', sortable: true},
          {key: 'marca', sortable: true},
          {key: 'cantidad', sortable: true},
          {key: 'subtotal', sortable: true},
      ]
    };
  },
  methods: {
    loadUp() {
      axios.get(loadUpApi + this.value).then((response) => {
        this.detalles = [];
        if (response.status) this.detalles = response.data;
      });
    },
  },
  created() {
    this.loadUp();
  },
};
</script>